<template>
  <b-modal centered hide-footer id="modal-lg" size="xl" ref="modal">
    <div>
      <b-img
        v-if="tipoResource == 'img'"
        :block="true"
        :fluid="true"
        :src="imgMidia"
        alt=" Carregando Imagem..."
      ></b-img>
      <b-embed
        v-else
        type="iframe"
        aspect="21by9"
        :src="imgMidia"
        allowfullscreen
      ></b-embed>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "ModalCopiaAit",

  components: {},

  props: {},

  data() {
    return {
      tituloModal: "",
      imgMidia: null,
      tipoResource: null,
    };
  },

  methods: {
    abrirSintetico(item, imgToPdf = false) {
      this.tituloModal = "Carregando ...";

      this.$api.Multa.buscarResourceAitPorTipo({ hash: item.hash })
        .then((response) => {
          this.tituloModal = item.num_ait_composto;
          if (response.data.success) {
            if (
              Object.prototype.hasOwnProperty.call(
                response.data.data,
                "ait_talao_manual"
              ) &&
              !imgToPdf
            ) {
              this.tipoResource = "img";
              this.imgMidia =
                "data:image/png;base64," + response.data.data.resource;
            } else {
              this.tipoResource = "pdf";
              this.imgMidia =
                "data:application/pdf;base64," + response.data.data.resource;
            }
          }
        })
        .then(this.$refs["modal"].show(), (this.imgMidia = null));
    },
  },
};
</script>

<style scoped>
</style>